module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5n1r2r-3d9151449d6d66d5ef526647b0b172a8.svg";